import React, { useEffect } from 'react';
import Navbar from './Component/Navbar'
import Footer from './Component/Footer';
import ContactUsForm from './Component/ContactUs/ContactUsForm';
import AssistanceSection from './Component/ContactUs/AssistanceSection';

import AOS from 'aos';
import 'aos/dist/aos.css'; // Import the AOS styles
import DeleteAccount from './Component/ContactUs/DeleteAccount';

const ContactUsLandingPage = () => {
    useEffect(() => {
        AOS.init({
            offset: 120,

            duration: 1000, // Set the duration of the animation
            easing: 'ease-in-out', // Set the easing function
            once: false, // Animation will run only once
        });
    }, []);
    return (
        <div>

            <DeleteAccount/>
            <div className="bg-black text-white pt-10 pb-10 px-10">
            <div className=" text-center text-gray-500">
        &copy; 2025 Pixell | Signthought Solutions Private Limited . All rights reserved.
        </div>
        </div>
</div>
    )
};
export default ContactUsLandingPage;
